// https://github.com/zeit/swr#global-configuration
export default {
  refreshInterval: 20000,
  fetcher: (...args) => fetch(...args).then(res => res.json())
}